import { IsString, MaxLength } from "class-validator";

export class AccountSearchDTO {
    
    @IsString()
    @MaxLength(50)
    name: string;

}
